
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<EmojiOptionSelector>({})
export default class EmojiOptionSelector extends Vue {
    @Prop({ type: Array, required: true }) private emojis!: []
    @Prop({ type: String }) private selected
}
